import React, { useEffect, useRef, useState } from 'react'
import { useDispatch } from 'react-redux'
import {
  Button,
  Form,
  Col,
  Row,
  Modal, notification, Card, AutoComplete
} from 'antd'
import _ from 'lodash'
import GetEachFormFields from '../../../components/_utils/appFormUtils'
import { singleQuotationFxn, getAgentsFxn, getFinalChangesInInrFxn, reeudoRatesFxn } from '../actions'
import { rupeeSymbol, fixed2Digit } from '../../../components/_utils/appUtils'
import { hidePageLoad, showPageLoad } from '../../../modules/actions'
import { listAllUniversities } from '../../university/actions/university'
import moment from 'moment'

const { Option } = AutoComplete
const RenderRow = (props) => {
  let { value, label, span } = props
  return (
    <Col span={span}>
      {label}
      <h5 className={'font-weight-600'}>{value}</h5>
    </Col>
  )
}
const AddQuotationForm = (props) => {
  const {
    form: { getFieldDecorator, setFieldsValue, getFieldValue },
    onClose,
    visible,
    onSubmit,
    currencyList,
    sourceId,
    quotationId,
    referenceUserList, currentUser,
    agentId,
    isForexOff,
    exchangeMargin,
    orgExchangeMargin,
    finalChangesState,
    formDataState,
    refreshRateFxn = () => null,
    purposeId,
    countryId,
    agentMargin,
    amount
  } = props
  let [selectedCurrencyObj, setSelectedCurrencyObj] = useState({})
  let [quotationData, setQuotationData] = useState(null)
  let [universityList, setUniversityList] = useState([])
  let dispatch = useDispatch()

  console.log(currencyList, 'currencyList')
  useEffect(() => {
    events.apiRequest()
    events.setDefaultValue()
  }, [])

  useEffect(() => {
    if (countryId) {
      loadCountryUniversity(countryId)
    }
  }, [countryId])


  const loadCountryUniversity = async (countryId) => {
    let filters = {
      sortField: 'universityName',
      sortOrder: 'ascend',
      results: 1000000,
      universityCountry: countryId
    }
    let { data } = await dispatch(listAllUniversities(filters))
    if (data) setUniversityList(data)
  }

  const events = {
    // setDefaultAgent: () => {
    //     if (currentUser && currentUser.userType == "agent") {
    //         setAgentId(currentUser._id)
    //     } else {
    //         setAgentId(ryanAgentId)
    //     }
    // },
    setDefaultValue: () => {
      setTimeout(() => {
        setFieldsValue({
          referencedBy: 'NA',
          exchangeMargin: exchangeMargin,
          agentMargin: agentMargin,
          ibrRate: fixed2Digit(finalChangesState && finalChangesState.yourRate) || '',
          quotationDate: moment()
        })
      }, 500)
    },

    chooseCurrency: (currency) => {
      let findDoc = _.find(currencyList, (item) => {
        return item.currency == currency
      })
      if (findDoc) {
        setSelectedCurrencyObj(findDoc)
      }
    },
    // getFinalCalculateRate: () => {
    //     return new Promise(async (resolve) => {
    //         let { data, success } = await dispatch(getFinalChangesInInrFxn(formDataState))
    //         if (success && data && data.charges) {
    //             resolve({ success: true, data: data.charges })
    //         } else {
    //             resolve({ success: false, data: {} })
    //         }
    //     })
    // },
    getFinalCalculateRate: () => {
      const ibr = parseFloat(getFieldValue('ibrRate') || 0)
      const exchMargin = parseFloat(getFieldValue('exchangeMargin') || 0)
      const agentMargin = parseFloat(getFieldValue('agentMargin') || 0)

      const customerRate = parseFloat((ibr + exchMargin + agentMargin).toFixed(2))
      const currency = getFieldValue('currency')

      const base = parseFloat((amount * customerRate).toFixed(2))


      let taxableValue = 0
      if (base > 1000000) {

        taxableValue = ((base - 1000000) * 0.001) + 5500
      } else if (base > 100000) {

        taxableValue = ((base - 100000) * 0.005) + 1000
      } else {

        taxableValue = base * 0.01
      }

      taxableValue = Math.min(Math.max(taxableValue, 250), 60000)

      const gst = taxableValue * 0.18
      //
      // const gst = parseFloat((taxableValue * 0.18).toFixed(2));

      // Charges
      const bank = currency === 'USD' ? 900 : 675
      const nostro = 0

      const totalBeforeTds = base + bank
      const tds = totalBeforeTds > 1000000 ? parseFloat(((totalBeforeTds - 1000000) * 0.05).toFixed(2)) : 0

      const total = parseFloat((totalBeforeTds + gst + tds).toFixed(2))

      const charges = {
        fromCurrency: currency,
        toCurrency: 'INR',
        fromCurrencyAmount: amount,
        toCurrencyAmount: base,
        finalPaymentAmounts: { CONSULTANT: base },
        paymentAmountBeforeDiscount: null,
        charges: {
          fromCurrency: currency,
          toCurrency: 'INR',
          fromCurrencyAmount: amount,
          gst,
          bank,
          nostro,
          tcs: tds,
          base,
          taxableValue: parseFloat(taxableValue.toFixed(2)),
          discount: 0,
          tds,
          fcyAmountInWords: amount.toString(),
          inrAmountInWords: total.toString(),
          fxRate: customerRate,
          ibrRate: ibr,
          yourRate: customerRate,
          youSave: 0,
          couponCode: null,
          couponRate: 0,
          nostroWaiveOff: 0,
          bankWaiveOff: 0,
          totalBeforeTds,
          total,
          partnerRate: 0,
          reeudoRate: 0,
          usdRate: 0
        }
      }

      return { success: true, data: charges.charges }
    },

    // refreshModal: () => {
    //     Modal.info({
    //         title: 'IBR Rate change, please refresh rate.',
    //         okText: 'Refresh Now',
    //         onOk: () => {
    //             refreshRateFxn()
    //         }
    //     })
    // },
    apiRequest: () => {
      return new Promise(async (resolve) => {
        let resp = await dispatch(singleQuotationFxn({ quotationId }))
        const response = resp.quotation

        if (response) {
          setQuotationData(response)

          setFieldsValue({
            currency: response.fromCurrency,
            amount: response.amount,
            fxRate: response.fxRate
          })
        }
        resolve({ data: response })
      })
    }

  }


  const inputTypes = {
    fields: [
      {
        key: 'ibrRate',
        label: 'IBR Rate',
        required: true,
        placeholder: 'IBR Rate',
        type: 'text'
      },
      {
        key: 'agentMargin',
        label: 'Agent Margin',
        required: true,
        placeholder: 'Agent Margin',
        type: 'text'
      },
      ...(currentUser.userType === 'admin' || currentUser.userType == 'reeudoManager' ? [
        {
          key: 'exchangeMargin', label: 'Uniz Margin', placeholder: 'Uniz Margin', type: 'text'

        }
      ] : []),
      {
        key: 'quotationDate',
        label: 'Quotation Date',
        required: true,
        placeholder: 'Select Date',
        type: 'date'
      },
      {
        key: 'studentName',
        label: 'Student Name',
        required: true,
        placeholder: 'Student Name',
        type: 'text'
      },
      {
        key: 'phoneNumber',
        label: 'Student Mobile Number',
        required: true,
        placeholder: 'Student Mobile Number',
        type: 'text'
      },
      {
        key: 'emailAddress',
        label: 'Student Email Id',
        required: true,
        placeholder: 'Student Email Id',
        type: 'text'
      },
      {
        key: 'panNumber',
        label: 'Pan Number',
        // required: true,
        placeholder: 'Pan Number',
        type: 'text'
      },

      {
        key: 'referencedBy',
        label: 'Reference By',
        placeholder: 'Reference By', type: 'select',
        options: referenceUserList,
        keyAccessor: x => x._id,
        valueAccessor: x => `${x.name}`,
        onChange: x => {
          // console.log(x);
          setFieldsValue({ referencedBy: x })
        }
      }

    ]
  }

  const formItemLayout = {
    labelCol: {
      xs: { span: 0 },
      sm: { span: 0 },
      md: { span: 0 }
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 24 },
      md: { span: 24 }
    }
  }

  const forexOffModal = () => {
    Modal.warning({
      title: 'Forex is closed',
      content: (
        <div>
          <p>Forex is Closed, Please try again between 8 a.m. and 4 p.m.</p>
        </div>
      ),
      onOk() {
      }
    })
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    if (isForexOff) {
      forexOffModal()
    } else {
      if (!getFieldValue('university')) {
        notification.warning({ message: 'Please choose/Enter University name.' })
        return
      }
      let { form } = props
      dispatch(showPageLoad())

      let { success, data } = await events.getFinalCalculateRate()
      console.log(data, 'data---------')
      dispatch(hidePageLoad())
      if (success) {
        if (data.yourRate == finalChangesState.yourRate) {
          nextProcess(data.yourRate, data)
        } else {
          // notification.warning({ message: `Rate change -  old Rate : ${finalChangesState.yourRate},  New Rate : ${data.yourRate}` })
          nextProcess(data.yourRate, data)
          //events.refreshModal()
        }
      } else {
        // events.refreshModal(finalChangesState.yourRate)
      }

      function nextProcess(yourRate, data) {
        form.validateFields((err, values) => {
          if (!err) {
            if (values.exchangeMargin < orgExchangeMargin) {
              notification.warning({ message: `Sry can't enter less then ${orgExchangeMargin}` })
              return
            }
            const submitValues = {
              ...values,
              sourceId: props.sourceId,
              agentId: agentId,
              purposeId: purposeId,
              countryId: countryId,
              yourRate,
              data

            }
            const universityName = values.university
            const matchedUni = universityList.find((uni) => universityName && uni.universityName.toLowerCase() === universityName.toLowerCase())

            submitValues.university = matchedUni ? {
              _id: matchedUni._id,
              universityName: matchedUni.universityName
            } : { universityName: universityName }
            onSubmit(submitValues)
          }
        })
      }
    }

  }

  const handleSearch = (inputText) => {
    if (
      inputText &&
      !universityList.some(
        (u) => u.universityName.toLowerCase() === inputText.toLowerCase()
      )
    ) {
      /*const customEntry = {
        _id: `custom-${inputText}`,
        universityName: inputText
      }*/
      setUniversityList((prevList) => [...prevList])
    }
  }

  const handleChange = (val) => {
    // setValue(val);
    setFieldsValue({ university: val })
    // form.setFieldsValue({ university: val }); // Works with antd v3 Form.create()
  }

  return (
    <Modal
      visible={visible}
      title={'Add Quotation'}
      onCancel={onClose}
      width={'45%'}
      footer={null}>
      <>

        <div className='card unizportal'>
          <Form onSubmit={handleSubmit}>
            <Row gutter={24}>
              {inputTypes.fields.map((item, key) => {
                return (
                  <Col span={item.span ? item.span : 12}
                       key={key}>
                    <GetEachFormFields
                      item={item}
                      className={'form-control'}
                      getFieldDecorator={getFieldDecorator}
                      formItemLayout={formItemLayout} />
                  </Col>
                )
              })}

              <Col span={12}>
                <Form.Item label='University'>
                  {getFieldDecorator('university', {
                    rules: [{ required: true, message: 'University is required' }]
                  })(
                    <AutoComplete
                      value={getFieldValue('university')}
                      placeholder='Add University'
                      className={'autoCompleted'}
                      onSearch={handleSearch}
                      onChange={handleChange}
                      filterOption={(inputValue, option) =>
                        option.props.children
                          .toLowerCase()
                          .includes(inputValue.toLowerCase())
                      }>
                      {universityList.map((uni) => (
                        <Option key={uni._id || uni.universityName} value={uni.universityName}>
                          {uni.universityName}
                        </Option>
                      ))}
                    </AutoComplete>
                  )}
                </Form.Item>
              </Col>
            </Row>


            <div>

              <Button htmlType='submit' className={'roundBtn'}>
                Submit
              </Button>


            </div>
          </Form>
        </div>
      </>
    </Modal>
  )
}

export default Form.create()(AddQuotationForm)
